// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xTMXcKF_L0DkOsSNTcbv {\n  margin-left: 0px;\n  margin-right: 0px;\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["webpack://./src/App/Pages/Home/Landing/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[":local(.container) {\n  margin-left: 0px;\n  margin-right: 0px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "xTMXcKF_L0DkOsSNTcbv"
};
export default ___CSS_LOADER_EXPORT___;
